// The canonical public origin, for absolute URLs that leave the app — share links,
// social meta, the iOS smart-banner app-argument. Deliberately not the host the
// visitor happens to be on: a link copied from a preview deploy should still point
// at the real site.
const configuredUrl = import.meta.env.VITE_CLIENT_URL || ''

export const SITE_ORIGIN = configuredUrl.replace(/\/+$/, '')

export function siteUrl(path = ''): string {
    return `${SITE_ORIGIN}${path}`
}
